import { render, staticRenderFns } from "./DigitalClinicsLogin.vue?vue&type=template&id=706c45f5&scoped=true"
import script from "./DigitalClinicsLogin.vue?vue&type=script&lang=js"
export * from "./DigitalClinicsLogin.vue?vue&type=script&lang=js"
import style0 from "./DigitalClinicsLogin.vue?vue&type=style&index=0&id=706c45f5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706c45f5",
  null
  
)

export default component.exports